import { makeStyles } from 'tss-react/mui';

export default makeStyles()({
    highlight: {
        fontWeight: 'bold'
    }
});
